<template>
  <div>
    <user-list :items="$store.state.user.users" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import UserMixin from '../mixins/UserMixin'
import UserList from '../components/user/UserList.vue'

export default {
  name: 'Users',
  components: {
    UserList
  },
  mixins: [UserMixin],
  methods: {
    ...mapActions('user', ['getUsersByCompany'])
  },
  mounted() {
    if (this.isSystemAdmin) {
      this.getUsersByCompany(this.$route.query.c)
    } else {
      this.getUsersByCompany(this.$store.state.auth?.user?.company)
    }
  }
}
</script>
